// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as AcademyTypes$LiteracyplanetClientSxEntry from "./AcademyTypes.res.mjs";
import * as AcademyMenuQueries$LiteracyplanetClientSxEntry from "./AcademyMenuQueries.res.mjs";

function AcademyData$Provider(props) {
  var onPlayActivity = props.onPlayActivity;
  var match = React.useState(function (param) {
        return "";
      });
  var setCurrentStrand = match[1];
  var match$1 = React.useState(function (param) {
        
      });
  var setCategory = match$1[1];
  var category = match$1[0];
  var match$2 = React.useState(function (param) {
        return "LEVEL_0";
      });
  var setLevel = match$2[1];
  var currentLevel = match$2[0];
  var onClickLevel = function (level) {
    Curry._1(setCategory, (function (param) {
            
          }));
    Curry._1(setLevel, (function (param) {
            return level;
          }));
  };
  var onClickStrand = function (category) {
    Curry._1(setCurrentStrand, (function (param) {
            return category.id;
          }));
    Curry._1(setCategory, (function (param) {
            return category;
          }));
  };
  var onClickCategory = function (category) {
    Curry._1(setCategory, (function (param) {
            return category;
          }));
  };
  var onClickActivity = function (activity) {
    Curry._1(onPlayActivity, activity.academyActivityId);
  };
  var query = AcademyMenuQueries$LiteracyplanetClientSxEntry.use(props.md5, currentLevel, category);
  React.useEffect((function (param) {
          if (query.loading || !Belt_Option.isNone(category)) {
            
          } else {
            Curry._1(setCurrentStrand, (function (param) {
                    return Belt_Option.mapWithDefault(Belt_Array.get(query.strands, 0), "", (function (s) {
                                  return s.id;
                                }));
                  }));
          }
        }), [query]);
  return React.createElement(AcademyTypes$LiteracyplanetClientSxEntry.Provider.make, {
              value: {
                onClickStrand: onClickStrand,
                onClickLevel: onClickLevel,
                onClickCategory: onClickCategory,
                onClickActivity: onClickActivity,
                currentLevel: currentLevel,
                currentStrand: match[0],
                query: query
              },
              children: props.children
            });
}

var Provider = {
  make: AcademyData$Provider
};

export {
  Provider ,
}
/* react Not a pure module */
